import "../App.css";
import React from "react";

import { useState } from "react";

const Connect = () => {

  const [name,setName] = useState('');
  const [email,setEmail] = useState('');
  const [message,setMessage] = useState('');
  const [url,setUrl] = useState('https://api.whatsapp.com/send?phone=+919676174309&text=');
  
  const handleNameChange = (e)=>{
    setName(e.target.value);
  }

  const handleEmailChange = (e)=>{
    setEmail(e.target.value);
  }

  const handleMessageChange = (e)=>{
    setMessage(e.target.value);
  }

  const formatMessage = ()=>{

    if(!name || !email || !message){
      alert("Please enter all details");
    }else{
      let newUrl = url + `From ${name}[${email}],%20`+ message.replace(' ','%20');
      setUrl(newUrl);
    }
    
    setName('');
    setEmail('');
    setMessage('');
  }

  return (
    <div className="connect">
      <h1>Send me a message</h1>
      <h3>Got a question or proposal, or just want to say hello? Go ahead.</h3>
      <div className="nameEmail">
        <input type="text" placeholder="name" onChange={handleNameChange} value={name} required/>
        <input type="email" placeholder="email" onChange={handleEmailChange} value={email} required/>
      </div>
      <input type="text" placeholder="message" onChange={handleMessageChange} value={message} required/>
      <a href={url} onClick={formatMessage} target="_blank">Shoot</a>
    </div>
  );
};

export default Connect;
